import React from 'react';

import FeaturedBrandCarousel from '../home/carousels/FeaturedBrand';
import FeaturedUserCarousel from '../home/carousels/FeaturedUser';
import SubSubCategoryCarousel from './carousels/SubSubCategory';

const ProductCarousel = props => (
  <div style={{ width: '100%', maxWidth: '100%' }}>
    <FeaturedUserCarousel user={props.user} productCarousel />
    {/* This is in order to not show the `-Otra-` brand carousel since it wouldn't make much sense. */}
    {props.brand.id &&
      props.brand.id !== 'f273ab70-db85-11ea-96d0-169ff7bc2d01' && (
        <FeaturedBrandCarousel brand={props.brand} productCarousel />
      )}
    <SubSubCategoryCarousel
      productCarousel
      subSubCategory={[props.subSubCategory]}
    />
  </div>
);

export default ProductCarousel;
